module.exports = "/davinci/assets/61b4f4abe8791a9da4bac3124ab41a81.png";